/**
 * FileStats 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * FileStats
 */
export interface FileStats {
  /** 创建时间（UTC） */
  created_at?: string
  /** 更新时间（UTC） */
  updated_at?: string
  /** 关联 file_info.id */
  file_id?: string
  /** 文件被查看的总次数 */
  view_count?: number
  /** 文件被点击的总次数 */
  click_count?: number
  /** 文件被下载的总次数 */
  download_count?: number
  /** 文件被分享的总次数 */
  share_count?: number
  /** 视频播放总次数 */
  play_count?: number
  /** 视频完整播放次数（播放进度>=90%） */
  complete_play_count?: number
  /** 视频总播放时长（秒） */
  total_play_duration?: number
  /** 平均播放进度（0-1之间的小数） */
  avg_play_progress?: number
  /** 图片全屏查看次数 */
  fullscreen_count?: number
  /** 图片放大查看次数 */
  zoom_count?: number
  /** 音频收听总次数 */
  listen_count?: number
  /** 音频完整收听次数（收听进度>=90%） */
  complete_listen_count?: number
  /** 文件获得的点赞数 */
  like_count?: number
  /** 文件相关的评论数 */
  comment_count?: number
  /** 文件被收藏的次数 */
  collect_count?: number
  /** 文件最后被查看的时间 */
  last_viewed_at?: string
  /** 视频/音频最后播放时间 */
  last_played_at?: string
}

/**
 * FileStats Schema
 */
export const FileStatsSchema: SchemaDefinition = {
  properties: {
    created_at: {
      description: '创建时间（UTC）',
      format: '*time.Time',
      type: 'string',
      label: '创建时间',
    },
    updated_at: {
      description: '更新时间（UTC）',
      format: '*time.Time',
      type: 'string',
      label: '更新时间',
    },
    file_id: {
      description: '关联 file_info.id',
      format: 'string',
      type: 'string',
      label: '关联',
    },
    view_count: {
      description: '文件被查看的总次数',
      format: 'int64',
      type: 'integer',
      label: '文件被查看的总次数',
    },
    click_count: {
      description: '文件被点击的总次数',
      format: 'int64',
      type: 'integer',
      label: '文件被点击的总次数',
    },
    download_count: {
      description: '文件被下载的总次数',
      format: 'int',
      type: 'integer',
      label: '文件被下载的总次数',
    },
    share_count: {
      description: '文件被分享的总次数',
      format: 'int',
      type: 'integer',
      label: '文件被分享的总次数',
    },
    play_count: {
      description: '视频播放总次数',
      format: 'int64',
      type: 'integer',
      label: '视频播放总次数',
    },
    complete_play_count: {
      description: '视频完整播放次数（播放进度>=90%）',
      format: 'int64',
      type: 'integer',
      label: '视频完整播放次数',
    },
    total_play_duration: {
      description: '视频总播放时长（秒）',
      format: 'int64',
      type: 'integer',
      label: '视频总播放时长',
    },
    avg_play_progress: {
      description: '平均播放进度（0-1之间的小数）',
      format: 'float64',
      type: 'number',
      label: '平均播放进度',
    },
    fullscreen_count: {
      description: '图片全屏查看次数',
      format: 'int',
      type: 'integer',
      label: '图片全屏查看次数',
    },
    zoom_count: {
      description: '图片放大查看次数',
      format: 'int',
      type: 'integer',
      label: '图片放大查看次数',
    },
    listen_count: {
      description: '音频收听总次数',
      format: 'int64',
      type: 'integer',
      label: '音频收听总次数',
    },
    complete_listen_count: {
      description: '音频完整收听次数（收听进度>=90%）',
      format: 'int64',
      type: 'integer',
      label: '音频完整收听次数',
    },
    like_count: {
      description: '文件获得的点赞数',
      format: 'int',
      type: 'integer',
      label: '文件获得的点赞数',
    },
    comment_count: {
      description: '文件相关的评论数',
      format: 'int',
      type: 'integer',
      label: '文件相关的评论数',
    },
    collect_count: {
      description: '文件被收藏的次数',
      format: 'int',
      type: 'integer',
      label: '文件被收藏的次数',
    },
    last_viewed_at: {
      description: '文件最后被查看的时间',
      format: '*time.Time',
      type: 'string',
      label: '文件最后被查看的时间',
    },
    last_played_at: {
      description: '视频/音频最后播放时间',
      format: '*time.Time',
      type: 'string',
      label: '视频/音频最后播放时间',
    },
  },
  type: 'object',
}
